export enum MarkerLayout {
  Basic = 'basic',
  Desk = 'desk',
  Extended = 'extended',
}
